import { bool, func, number, oneOf, oneOfType, string } from "prop-types";

/*
    If you change the structure in this file, you must check:
        CustomText.js and ExampleText.js

    (This will not break any component that is using
        CustomText if you just add keys)
*/

/* CustomText Data Structure Guide */
export const customTextDataStructureGuide = {
    text: oneOfType([string, number]),
    textType: oneOf(["STRING", "MONEY", "NUMBER", "PERCENTAGE", "DATE", "I18N", "ARS", "USD"]),
    className: string,
    keepSpaceIfNoText: bool,
};

/* CustomText PropType */

export const currencies = ["ARS", "USD", "EUR", "BRL", "CAD", "CLP", "GBP", "JPY", "UYI", "UYU"];
export const textTypes = ["STRING", "MONEY", "NUMBER", "PERCENTAGE", "DATE", "I18N", ...currencies];

export const customTextPropType = {
    text: oneOfType([string, number]),
    textType: oneOf(textTypes),
    className: string,
    keepSpaceIfNoText: bool,
    dateFormat: string,
    showTooltip: bool,
    onTooltipClick: func,
};

export const defaultCustomTextPropType = {
    text: "",
    textType: "STRING",
    className: "",
    keepSpaceIfNoText: true,
    dateFormat: "DD/MM/YYYY",
    showTooltip: false,
    onTooltipClick: () => {},
};
